import { Paper, Typography } from "@mui/material";
import React from "react";
import LineChart from "../../../components/Dashboard/LineChart";
import Template from "../../../components/Dashboard/Template";
import appcolors from "../../../constants/Colors";

function MainChart({ data }) {
  const totalEarnings = data.reduce(
    (acc, item) => acc + (item?.totalEarning || 0),
    0
  );
  const totalAppointments = data.length;
  return (
    <Template
      primaryHeading={`Total Completed Appointments Earnging : ${totalEarnings} SAR`}
      secondaryHeading={`Appointments : ${totalAppointments}`}
    >
      {data?.length > 0 ? (
        <LineChart chartHeight={340} data={data} />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
        >
          No Chart Data Found!
        </Typography>
      )}
    </Template>
  );
}

export default MainChart;
